import type { TableProps } from 'antd/es/table';
import type { UploadRow, UploadsTableConfigOptions } from './types';
import { buildColumns } from './columns';
import { components, rowClassName, onRow } from './tableComponents';

export function createUploadsTableConfig(opts?: UploadsTableConfigOptions) {
  const columns = buildColumns(opts);
  return {
    columns,
    components,
    rowClassName,
    onRow,
  } as {
    columns: ReturnType<typeof buildColumns>;
    components: TableProps<UploadRow>['components'];
    rowClassName: (row: UploadRow) => string;
    onRow: NonNullable<TableProps<UploadRow>['onRow']>;
  };
}
